var render = function () {
  var _vm$order, _vm$order$summary, _vm$order2, _vm$order2$summary;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "total dark-yellow-text",
    class: [("total_" + (_vm.color))]
  }, [_c('div', {
    staticClass: "total__props-wrapper total__props-wrapper_total"
  }, [_c('p', {
    staticClass: "total__prop"
  }, [_vm._v("\n      Итого\n    ")]), _vm._v(" "), _c('span', {
    staticClass: "total__value"
  }, [_vm._v("\n      " + _vm._s(_vm.totalPrice) + "₽\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "total__props-wrapper"
  }, [_c('p', {
    staticClass: "total__prop total__count"
  }, [_vm._v("\n      Товары,\n      "), _c('span', {
    staticClass: "total__items-count"
  }, [_vm._v(_vm._s(_vm.total.activeQuantity))]), _vm._v("\n      шт:\n    ")]), _vm._v(" "), _c('span', {
    staticClass: "total__value total__products-price"
  }, [_vm._v("\n      " + _vm._s(_vm.total.price.product) + "₽\n    ")])]), _vm._v(" "), _vm.total.price.discount ? _c('div', {
    staticClass: "total__props-wrapper"
  }, [_c('p', {
    staticClass: "total__prop"
  }, [_vm._v("\n      Скидка:\n    ")]), _vm._v(" "), _c('span', {
    staticClass: "total__value"
  }, [_vm._v("\n      " + _vm._s(_vm.total.price.discount) + "₽\n    ")])]) : _vm._e(), _vm._v(" "), (_vm$order = _vm.order) !== null && _vm$order !== void 0 && (_vm$order$summary = _vm$order.summary) !== null && _vm$order$summary !== void 0 && _vm$order$summary.bonusSpent ? _c('div', {
    staticClass: "total__props-wrapper"
  }, [_c('p', {
    staticClass: "total__prop"
  }, [_vm._v("\n      Скидка бонусами:\n    ")]), _vm._v(" "), _c('span', {
    staticClass: "total__value"
  }, [_vm._v("\n      " + _vm._s((_vm$order2 = _vm.order) === null || _vm$order2 === void 0 ? void 0 : (_vm$order2$summary = _vm$order2.summary) === null || _vm$order2$summary === void 0 ? void 0 : _vm$order2$summary.bonusSpent) + "₽\n    ")])]) : _vm._e(), _vm._v(" "), _vm.delivery ? _c('div', {
    staticClass: "total__props-wrapper"
  }, [_c('p', {
    staticClass: "total__prop"
  }, [_vm._v("\n      Цена доставки:\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "total__value total__delivery-price"
  }, [_c('p', [_vm._v("\n        " + _vm._s(_vm.delivery.price ? ((_vm.delivery.price) + "₽") : 'Бесплатно') + "\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "fz-10 lh-16"
  }, [_vm._v("\n        " + _vm._s(_vm.delivery.title) + "\n      ")])])]) : _vm._e(), _vm._v(" "), _vm.total.bonus.income > 0 && _vm.isUser ? _c('div', {
    staticClass: "total__props-wrapper"
  }, [_c('p', {
    staticClass: "total__prop"
  }, [_vm._v("\n      Вернётся бонусами:\n    ")]), _vm._v(" "), _c('TSBonusCount', {
    attrs: {
      "count": _vm.total.bonus.income
    }
  })], 1) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }